<mat-dialog-content class="dialog-content">
  <section>
    <mds-grid
      [storageKey]="'data-sources-settings'"
      [minHeight]="'100%'"
      [overrides]="overrides"
      [sizeColumnsToFit]="true"
      [themeClass]="'ag-theme-material'"
      (gridReady)="onGridReady($event)">
    </mds-grid>
  </section>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <mds-button
    (click)="openAddDialog()"
    [disabled]="isProcessing"
    aria-label="Add Data Source" role="button" type="primary">Add Data Source
  </mds-button>
</mat-dialog-actions>
